async function getEmpresaFaturamento(cnpj) {
  try {
    const response = await fetch(process.env.REACT_APP_LABS_API + "get_account_data.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ cnpj }),
    });
    const data = await response.json();
    return (data && (data.fantasia || data.nome)) || "";
  } catch (error) {
    return "";
  }
}

async function getConectaPedido({ id, laboratorio }) {
  const headers = {
    "Content-Type": "application/json",
    access_token: sessionStorage.getItem("token"),
    client_id: localStorage.getItem("clientid"),
  };
  if (laboratorio) headers.laboratorio = laboratorio;

  try {
    const response = await fetch(
      `${process.env.REACT_APP_ESSILOR_API}gestao-pedidos-laboratorio/v1/conecta-pedidos/${id}`,
      { method: "GET", headers }
    );

    const json = await response.json().catch(() => ({}));

    if (response.status !== 200 || json?.hasOwnProperty?.("codigo")) {
      return { status: response.status, pedido: null, erro: json?.mensagem || "Erro ao recuperar o pedido." };
    }

    if (json?.cliente?.cnpj) {
      json.cliente.empresaFaturamento = await getEmpresaFaturamento(json.cliente.cnpj);
    }

    return { status: response.status, pedido: json, erro: "" };
  } catch (error) {
    return { status: 0, pedido: null, erro: "Falha de comunicação com o servidor." };
  }
}

export { getConectaPedido };
